import { ContactIcon } from "src/icons/navigation-icons/contact-icon";
import { ReservationsIcon } from "src/icons/navigation-icons/reservations-icon";
import { SettingsIcon } from "src/icons/navigation-icons/settings-icon";
// import { SpotsIcon } from "src/icons/navigation-icons/spots-icon";
import { RouteTitle, SidebarRouteTitle } from "src/types/enum/route-title";
import { RoutesGroup } from "src/types/interfaces/routes-group";

export const getSecurityRoutes = (): RoutesGroup[] => [
  {
    title: SidebarRouteTitle.PARKING,
    routes: [
      {
        icon: ReservationsIcon,
        title: RouteTitle.RESERVATIONS_SECURITY,
        href: "/reservations",
        id: "security_reservations_navigation_link",
      },
      //temporary disabled
      // {
      //   icon: SpotsIcon,
      //   title: RouteTitle.PARKING_SPOTS,
      //   href: "/resource/spots",
      //   id: "security_parking_spots_navigation_link",
      // },
    ],
  },
  {
    title: SidebarRouteTitle.SUPPORT_AND_SETTINGS,
    routes: [
      {
        icon: SettingsIcon,
        title: RouteTitle.PASSWORD,
        href: "/settings/change-password",
        id: "password_change_navigation_link",
      },
      {
        icon: ContactIcon,
        title: RouteTitle.CONTACT_FORM,
        href: "/settings/contact-form",
        id: "contact_form_navigation_link",
      },
    ],
  },
];
